export default "__VITE_ASSET__ckH2$CAF__"